import { Service } from "./Service.js";

export class AnalyticsService extends Service {
  #debugEnabled = false;

  constructor() {
    super();
    this.#debugEnabled = window.debug === true;
    this.gtag = window.gtag;
  }

  /**
   * Fire an event.
   * @param {string} name
   * @param {object} properties
   */
  event(name, properties = {}) {
    if (this.#debugEnabled) {
      console.log("AnalyticsService.event", name, properties);
    }
    this.gtag("event", name, properties);
  }
}
